<template>

  <header class="" v-bind:class="{ 'white--bg': !darken, 'header-alt': darken, }">

      <w-flex class="wrapper mt-0 justify-space-between">


             <w-flex align-left>

      <div class="box mr2">
           <w-button
             class="mr2"
             lg
             :icon="menu ? 'fal fa-angle-double-left' : 'fal fa-angle-double-right'"
             bg-color="transparent"
             @click="showmenu"
           />
      </div>

      <div class="box mt1">
        <w-breadcrumbs :items="crumbs">
          <template #separator color="white">\</template>
        </w-breadcrumbs>
      </div>

      </w-flex>


         <div v-if="0">
            <w-icon
              class="ml2"
              md
              color="grey-light5">
              fal fa-signal
            </w-icon>
            <w-icon
              class="ml2"
              md
              color="grey-light5">
              fal fa-wifi
            </w-icon>
            <w-icon
              class="ml2"
              md
              color="grey-light5">
              fal fa-battery-bolt
            </w-icon>
         </div>

         <div class="justify end no-shrink row leftbox">
            <!-- <w-menu
               min-width="200"
               shadow
               align-right
               color="white"
               bg-color="indigo-dark4"
               content-class="ma0 pa0"
               >
               <template #activator="{ on }">
                  <w-badge v-on="on"
                     class="mr5"
                     bg-color="red"
                     color="primary-white"
                     overlap lg>
                    <template #badge>{{ pesan.length }}</template>
                    <w-icon class="fail" lg>fal fa-envelope</w-icon>
                  </w-badge>
               </template>
               <div class="notification-container">
                  <w-card class="notification-header">
                     <template #badge>{{ pesan.length }}</template>
                     <w-icon class="notification-icon" lg>fal fa-envelope</w-icon>
                     <span>Pesan</span>
                  </w-card>
                  <div class="notification-list">
                     <w-list :items="pesan">
                        <template #item="{ item, index }" >
                           <div class="notification-item" @click="openDetailMsg(item, index)">
                              <w-icon class="user-avatar">fal fa-user-circle</w-icon>
                              <div class="notification-content">
                                 <span class="notification-title">{{item.sumber}}</span><br>
                                 <span class="notification-body">{{ item.catatan }}</span>
                                 <span class="notification-tag">
                                    <w-tag
                                      class="mr4"
                                      round>
                                      {{ item.status }}
                                    </w-tag>
                                 </span>
                                 <div class="notification-time">{{ item.tanggal}}</div>
                                 <div class="mark-read" @click="openDetailMsg(item, index)">
                                   <w-icon class="mark-icon">fal fa-check-circle</w-icon>
                                   <span>Baca</span>
                                 </div>
                              </div>
                           </div>
                        </template>
                     </w-list>
                  </div>
              </div>

            </w-menu> -->
            <w-menu
               min-width="200"
               shadow
               align-right
               color="white"
               bg-color="indigo-dark4"
               content-class="ma0 pa0"
               >
               <template #activator="{ on }">
                  <w-badge v-on="on"
                     class="mr5"
                     bg-color="red"
                     color="primary-white" overlap lg>
                     <template #badge>{{ notifications.length }}</template>
                     <w-icon class="fail" lg>fal fa-bell</w-icon>
                  </w-badge>
               </template>
               <div class="notification-container">
                  <w-card class="notification-header">
                     <template #badge>{{ notifications.length }}</template>
                     <w-icon class="notification-icon" lg>fal fa-bell</w-icon>
                     <span>Notifikasi</span>
                  </w-card>
                  <div class="notification-list">
                     <w-list :items="notifications">
                        <template #item="{ item, index }" >
                              <a :href="item.url" @click="opemDetailNtf(item, index)">
                           <div class="notification-item" :class="'unread'">
                              <w-icon class="user-avatar">fal fa-user-circle</w-icon>
                              <div class="notification-content">
                                 <span class="notification-title">{{item.sumber}}</span><br>
                                 <span class="notification-body">{{ item.catatan }}</span>
                                 <span class="notification-tag">
                                 <w-tag
                                    class="mr4"
                                    round>
                                    {{ item.status }}
                                 </w-tag>
                                 </span>
                                 <div class="notification-time">{{ item.tanggal}}</div>
                                 <div class="mark-read">
                                    <div class="item-icon"> </div>
                                   <span>Baca</span>
                                 </div>
                              </div>
                           </div>
                              </a>
                        </template>
                     </w-list>
                     <w-list :items="pesan">
                        <template #item="{ item, index }" >
                              <a :href="item.url" >
                           <div class="notification-item" :class="'read'">
                              <w-icon class="user-avatar">fal fa-user-circle</w-icon>
                              <div class="notification-content">
                                 <span class="notification-title">{{item.sumber}}</span><br>
                                 <span class="notification-body">{{ item.catatan }}</span>
                                 <span class="notification-tag">
                                 <w-tag
                                    class="mr4"
                                    round>
                                    {{ item.status }}
                                 </w-tag>
                                 </span>
                                 <div class="notification-time">{{ item.tanggal}}</div>
                                 <div class="mark-read">
                                   <w-icon class="mark-icon">fal fa-check-circle</w-icon>
                                   <span>Baca</span>
                                 </div>
                              </div>
                           </div>
                              </a>
                        </template>
                     </w-list>
                  </div>
               </div>
            </w-menu>

            {{ $page.props.auth.user.name }}
            &nbsp;
            <w-image
               class="mr1 ml1 bd1 sh1 bdrs1 d-block white--bg"
               :src="$page.props.auth.user.avatar"
               :width="30"
               :height="30">
            </w-image>

            <w-menu
               min-width="200"
               shadow
               align-right
               color="white"
               bg-color="indigo-dark4"
               content-class="ma0 pa0"
               >
                  <template #activator="{ on }">
                     <w-icon
                        v-on="on"
                        class="mr-2"
                        md
                        color="grey-light5">
                        fal fa-bars
                     </w-icon>
                  </template>
               <z-menu
                  :menu="menus"
                  icon-expand="fal fa-chevron-up"
               />
            </w-menu>
               &nbsp;&nbsp;&nbsp;
         </div>
      </w-flex>

     <!--  <w-dialog
         v-model="dialog1.show"
         :fullscreen="dialog1.fullscreen"
         width="600"
         :persistent="dialog1.persistent"
         :persistent-no-animation="dialog1.persistentNoAnimation"
         title-class="primary-dark1--bg white">
         <template #title>
            <template v-if="pesanSelected.jenis==2">
            <w-icon class="fail" lg>fal fa-bell</w-icon>&nbsp;
            Notifikasi
            </template>
         </template>{{isListVisible}}
         <div class="modal-content">
            <div class="notification-time">{{pesanSelected.tanggal }}</div>
            <span class="notification-title">{{pesanSelected.sumber}}</span><br>
            <span class="notification-body">{{ pesanSelected.catatan }}</span><br>
            <span class="notification-tag">
               <w-tag
                  class="mr4"
                  round>
                  {{ pesanSelected.status }}
               </w-tag>
            </span><br><br>
            <inertia-link
               :href="pesanSelected.url"
               class="w-button green--bg  w-button--dark ml1" style="width: 70px;">
               <w-icon class="mr1">fal fa-share</w-icon>
                 Buka
            </inertia-link>
         </div>
         <template #actions>
            <div class="spacer" />
            <w-button bg-color="grey-dark2--bg" @click="tutupDetailMsg()">TUTUP</w-button>
         </template>
      </w-dialog> -->
  </header>

</template>

<script>
import ZMenu from './Menu'

export default {
  components:{
    ZMenu
  },
  props: {
    crumbs: [Object, Array]

  },
  data() {
    return {
      hover: false,
      menu: true,
      autohidemenu: false,
      darken: false,
      attahecment: [],
      isListVisible: false,
      pesanSelected: {},
      pesan: [],
      jenis: 0,
      notifications: [],
      menus: [
        {label: 'Utama', icon: 'fal fa-home', route: '/home', remove: 'no', child: []},
        {label: 'Profil', icon: 'fal fa-edit', route: '/profile', remove: 'no', child: []},
        {label: 'Kemaskini Kata Laluan', icon: 'fal fa-lock', route: '/ubah-katalaluan', remove: 'no', child: []},
        {label: 'Keluar', icon: 'fal fa-sign-out', route: '/logout', remove: 'no', child: []}
      ],
      dialog1: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 500,
          item: {name: '', email: '', mobile: ''}
      },
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll)
    window.addEventListener("mousemove", this.onMouseMove)
     this.notifications = this.$page?.props?.auth?.user?.unread?.items ?? [];
     this.pesans();
    // document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("mousemove", this.onMouseMove)
    // document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
   pesans(){
      this.$zcomm.get(this.api_service + 'lookup/pesan', {}).then(res => {
         this.pesan = res.data?.items || [];
      })
    //   console.log(this.$page.props.auth.user.unread.items);
   },
   toggleNotifications(){
      this.isListVisible = !this.isListVisible;
   },
   opemDetailNtf(notifications, index){
        // this.isListVisible=this.isListVisible;
        // this.pesanSelected=notifications;
        // this.pesanSelected.jenis=2;
        // this.dialog1.show=true;
        this.$zcomm
        .patch("notif-read", notifications.id, {})
        .then((res) => {
           this.notifications.splice(index,1);
        });
   },
   tutupDetailNtf(){
     this.dialog1.show=false;
     this.isListVisible = false;
   },
   openDetailMsg(notifications, index){
        this.isListVisible=this.isListVisible;
        this.pesanSelected=notifications;
        this.pesanSelected.jenis=1;
        this.dialog1.show=true;
   },
   tutupDetailMsg(){
     this.dialog1.show=false;
     this.isListVisible = false;
   },
    showmenu() {
      this.menu = !this.menu
      this.autohidemenu = !this.menu
      localStorage.setItem('showmenu', this.menu)
    },
    onScroll(e) {
      let y = window.top.scrollY /* or: e.target.documentElement.scrollTop */

      if(y > 70) {
        this.darken = true
      } else {
        this.darken = false
      }


    },
    onMouseMove(e) {
    let x = e.clientX
    if(x <= 0 && !this.menu) {
      this.menu = true
      this.autohidemenu = false
    }

    if(x >= 250 && this.autohidemenu) {
      this.menu = false
    }
  },
    handleClickOutside(event) {
      // Detect if click is outside the notification container
      if (this.isListVisible && this.$refs.notificationContainer && !this.$refs.notificationContainer.contains(event.target)) {
        this.isListVisible = false;
      }
    },

  },
  watch: {
    menu: function (val) {
      if(val) {
        document.getElementsByClassName('zsidebar')[0].classList.remove('zhidemenu')
      } else {
        document.getElementsByClassName('zsidebar')[0].classList.add('zhidemenu')
      }
    }
  }
}
</script>

<style scoped>
/*.w-breadcrumbs {
  color: white !important;
}

a.w-breadcrumbs__item {
    color: white !important;
}
.w-breadcrumbs__separator {
    margin-left: 4px;
    margin-right: 4px;
    color: white !important;
}*/
::v-deep(.w-breadcrumbs),
::v-deep(.w-breadcrumbs__item),
::v-deep(.w-breadcrumbs__separator),
::v-deep(.w-breadcrumbs a),
::v-deep(.w-breadcrumbs a:hover),
::v-deep(.w-breadcrumbs a:visited) {
  color: white !important;
}
.notification-title {
  font-weight: bold;
  color: #333;
  margin-right: 2px;
}

/*.notification-container {
  width: 320px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #fff;
  padding: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}
*/
/*.notification-header {
  display: flex;
  align-items: flex-start;
  padding: 2px;
  font-size: 18px;
   color: #000000;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ccc;
}*/

/*.notification-icon {
  margin-right: 8px;
  color: #007bff;
}
*/
/*.notification-item {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  border-bottom: 1px solid #eee;
}*/

/*.user-avatar {
  font-size: 36px;
  margin-right: 10px;
  color: #007bff;
}
*/
.notification-content {
  flex-grow: 1;
}

.user-name {
  font-weight: bold;
  color: #333;
}

.notification-body {
  color: #555;
  font-size: 14px;
  margin: 4px 0;
}

.notification-tag {
  margin: 4px 0;
  font-size: 12px;
  color: #555;
}


.mark-icon {
  margin-right: 4px;
}

.view-all {
  text-align: center;
  padding: 8px 0;
  background-color: #f9f9f9;
}

.view-all a {
  color: #007bff;
  text-decoration: none;
  font-weight: bold;
}

.view-all a:hover {
  text-decoration: underline;
}
.notification-list {
  max-height: 300px;
  overflow-y: auto;
}

.notification-list::-webkit-scrollbar {
  width: 6px;
}

.notification-list::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.notification-list::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.modal-content{
   color: black;
}

header  {
  /* text-transform: uppercase; */
  margin: 0px;
  padding: 12px;
  min-height: 20px;
  position: fixed;
  width: 100%;

  }

  .header-alt {
    background-color: rgba(24,26,60, 0.9);
    position: fixed;
    transition: all 0.5s;
  }

  .leftbox {
    display: flex;
    align-items: center;
  }
  .header-bottom{
    border-bottom: 1px solid #fff;
    border-top: 1px solid #e4e9f0;
    z-index: 1;
    padding: 1rem 1.5rem;
    box-shadow: 0 0 1px #0000001a, 3px 3px 12px #00000039;

  }
  .profile-name{
    font-weight: bold;
    font-size: 17px;
    align-items: center;

  }
  .notification-container {
  width: 340px;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0,0,0,0.12);
}

.notification-header {
  display: flex;
  align-items: center;
  padding: 14px 18px;
  font-size: 18px;
  font-weight: 600;
  color: #1f1f1f;
  border-bottom: 1px solid #e5e6ea;
  background: linear-gradient(to right, rgb(51 47 127), rgb(69 64 169));
  color: white;
}

.notification-icon {
  margin-right: 10px;
  font-size: 22px;
}


.notification-list {
  max-height: 360px;
  overflow-y: auto;
}

.notification-list::-webkit-scrollbar {
  width: 6px;
}
.notification-list::-webkit-scrollbar-thumb {
  background-color: #c5c5c5;
  border-radius: 4px;
}

.notification-item {
  display: flex;
  padding: 14px;
  border-bottom: 1px solid #f2f2f2;
  transition: background 0.15s ease;
}

.notification-item:hover {
  background: #f8f9ff;
}

.user-avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: #e9edff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px !important;
  color: #3f4bd6;
  margin-right: 14px;
}

.notification-content {
  flex: 1;
  font-size: 14px;
}

.notification-title {
  font-weight: 700;
  font-size: 15px;
  color: #222;
}

.notification-body {
  color: #555;
  font-size: 13px;
}

.notification-tag w-tag {
  background: #f0f3ff;
  color: #4255d0;
  padding: 2px 8px;
  font-size: 11px;
}

.notification-time {
  color: #8c8c8c;
  font-size: 12px;
  margin-top: 4px;
}

.mark-read {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
}

.mark-read .mark-icon {
  font-size: 14px;
  margin-right: 5px;
}

.item-icon {
   width: 10px;
  height: 10px;
  background-color: #3756ff; /* biru pekat */
  border-radius: 50%;
  display: inline-block;
}

.notification-item a {
  text-decoration: none;
  color: inherit;
}

/* Belum dibaca */
.notification-item.unread {
  background: #eef2ff;   /* biru lembut */
  position: relative;
}

/* Sudah dibaca */
.notification-item.read {
  background: #ffffff;
  opacity: 0.85;
}

.notification-item.read:hover {
  background: #f8f9ff;
  opacity: 1;
}



</style>
